import { render, staticRenderFns } from "./ReportPayments.vue?vue&type=template&id=67cfa04f&scoped=true&"
import script from "./ReportPayments.vue?vue&type=script&lang=js&"
export * from "./ReportPayments.vue?vue&type=script&lang=js&"
import style0 from "./ReportPayments.vue?vue&type=style&index=0&id=67cfa04f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cfa04f",
  null
  
)

export default component.exports